module.exports = __webpack_public_path__ + "imgs/PlannedParenthood.aad3f017d4b10d92e2e7ca93f7016a7e.png";